<div class="toast-container">
  <ng-container *ngIf="toasts.length">
    <div *ngFor="let toast of toasts" class="toast flex radius-small u-text-black shadow-medium u-bg-white">
      <div class="w-full flex  h-full">

        <!-- <div style="min-height: 62px; border-radius: 4px 0px 0px 4px;" [ngClass]="'bg ' + toast.type"
          class="w-10 h-full">
        </div> -->

        <div class="u-fs-14 w-full u-gap-12 flex-center fw-400">
          <div class="w-28 radius-huge light-bg h-28 flex-center" [ngClass]="toast.type">
            <ng-container [ngSwitch]="toast.type">
              <span *ngSwitchCase="'success'"><i class="fas fa-check-circle u-text-success"></i></span>
              <span *ngSwitchCase="'error'"><i class="fas fa-exclamation-circle u-text-error"></i></span>
              <span *ngSwitchCase="'info'"><i class="fas fa-info-circle u-text-neutral"></i></span>
              <span *ngSwitchCase="'warning'"><i class="fas fa-exclamation-triangle u-text-warning"></i></span>
              <span *ngSwitchCase="'loading'"><i class="fas fa-spinner fa-spin u-text-neutral"></i></span>
              <span *ngSwitchDefault>🔔</span>
            </ng-container>
          </div>
          <p style="width: 80%;">
            {{ toast.message }}
          </p>

        </div>

      </div>
    </div>
  </ng-container>
</div>